import { useMemo } from "react";

export type EntityWithId = {
  id: number;
};

const useFindEntityById = <T extends EntityWithId>(
  entities: T[],
  entityId?: string,
): T => {
  const selectedEntity = useMemo(() => {
    if (entityId) {
      const numEntityId = parseInt(entityId, 10);

      return entities.find((e) => e.id === numEntityId);
    }

    return null;
  }, [entities, entityId]);

  return selectedEntity;
};

export default useFindEntityById;
